import { useState } from 'react';
import { ChevronDown, MessageCircle } from 'lucide-react';

const FAQS = [
  {
    question: '¿Es realmente gratis?',
    answer: 'Sí, el plan Free es gratis para siempre. Incluye registro de gastos, presupuestos básicos y dashboard. Solo pagas si quieres funciones avanzadas como metas de ahorro, modo pareja o exportar datos.',
  },
  {
    question: '¿Puedo usarlo con mi pareja sin que vea todo?',
    answer: 'En el modo pareja, ambos ven el balance compartido y los gastos comunes. Pero cada uno mantiene su privacidad en gastos personales si así lo configuran. Ustedes deciden qué compartir.',
  },
  {
    question: '¿Mis datos están seguros?',
    answer: 'Absolutamente. Usamos encriptación de grado bancario (AES-256). Tus datos financieros nunca se venden a terceros. Puedes exportar o eliminar tu información en cualquier momento.',
  },
  {
    question: '¿Funciona en mi país?',
    answer: 'Kuadra2 funciona en cualquier país. Soportamos múltiples monedas (CLP, MXN, ARS, USD, EUR, etc.) y puedes cambiar la moneda en cualquier momento.',
  },
  {
    question: '¿Puedo importar datos de otra app?',
    answer: 'Sí, puedes importar datos desde Excel/CSV. También estamos trabajando en integraciones directas con bancos (próximamente).',
  },
  {
    question: '¿Qué pasa si cancelo mi suscripción?',
    answer: 'Si cancelas Pro o Familia, vuelves al plan Free automáticamente. Conservas todos tus datos históricos, solo pierdes acceso a las funciones premium.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="py-20 px-4 bg-gray-50 dark:bg-gray-900/50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-brand-100 dark:bg-brand-500/10 text-brand-600 dark:text-brand-400 text-xs font-semibold mb-4">
            PREGUNTAS FRECUENTES
          </span>
          <h2 className="text-3xl sm:text-4xl font-display font-bold text-gray-900 dark:text-white mb-4">
            ¿Tienes dudas?
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            Aquí respondemos las preguntas más comunes
          </p>
        </div>

        <div className="space-y-3">
          {FAQS.map((faq, i) => (
            <div
              key={i}
              className={`bg-white dark:bg-gray-900 rounded-xl border transition-all ${
                openIndex === i
                  ? 'border-brand-200 dark:border-brand-800 shadow-md'
                  : 'border-gray-200 dark:border-gray-800'
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
                className="w-full flex items-center justify-between p-5 text-left"
              >
                <span className="font-semibold text-gray-900 dark:text-white pr-4">{faq.question}</span>
                <ChevronDown
                  size={20}
                  className={`text-gray-400 shrink-0 transition-transform ${
                    openIndex === i ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-600 dark:text-gray-400 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="mt-10 text-center p-6 bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800">
          <MessageCircle size={32} className="text-brand-500 mx-auto mb-3" />
          <h3 className="font-semibold text-gray-900 dark:text-white mb-2">¿Otras preguntas?</h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
            Escríbenos y te respondemos en menos de 24 horas
          </p>
          <a
            href="mailto:hola@kuadra2.app"
            className="inline-flex items-center gap-2 text-brand-600 dark:text-brand-400 font-semibold hover:underline"
          >
            hola@kuadra2.app
          </a>
        </div>
      </div>
    </section>
  );
}
